<template>
  <dl class="upsi-summary-list" data-testid="upsi-summary-list">
    <div
      v-for="(row, index) in rows"
      :key="`${row.label}-${index}`"
      class="upsi-summary-list__row"
    >
      <dt class="upsi-summary-list__label">{{ row.label }}</dt>
      <dd
        class="upsi-summary-list__value"
        :class="{ 'upsi-summary-list__value--truncate': truncatesValue(row) }"
      >
        <FcTooltip
          v-if="truncatesValue(row)"
          :text="valueText(row)"
          placement="bottom"
          fixed
          eager
          transition="fade-transition"
          content-class="tooltip-wrap upsi-summary-list__tooltip"
          activator-class="upsi-summary-list__value-activator"
          :disabled="!truncated[index]"
          :focusable="!!truncated[index]"
        >
          <span
            class="upsi-summary-list__value-text"
            :class="{ 'upsi-summary-list__value-text--overflow': truncated[index] }"
            :ref="`valueText-${index}`"
          >{{ row.value }}</span>
        </FcTooltip>
        <template v-else>{{ row.value }}</template>
      </dd>
    </div>
  </dl>
</template>

<script>
import './UpsiSummaryList.scss';
import { FcTooltip } from '@/modules/financialclose/components';
import { UPSI_SUMMARY_LABELS } from '../../components/upsi/upsiDialogUtils';

/** Key/value rows for UPSI dialog summaries. */
export default {
  name: 'UpsiSummaryList',

  components: {
    FcTooltip,
  },

  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      truncated: {},
    };
  },

  watch: {
    rows() {
      this.observeValues();
    },
  },

  mounted() {
    this.observeValues();
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },

  methods: {
    truncatesValue(row) {
      const label = row && row.label;
      return label === UPSI_SUMMARY_LABELS.FILING_REFERENCE
        || label === UPSI_SUMMARY_LABELS.UPSI_STATUS;
    },

    valueText(row) {
      if (!row || row.value == null) return '';
      return String(row.value);
    },

    valueEl(index) {
      const el = this.$refs[`valueText-${index}`];
      if (Array.isArray(el)) return el[0] || null;
      return el || null;
    },

    observeValues() {
      this.$nextTick(() => {
        if (typeof ResizeObserver === 'undefined') {
          this.measureValues();
          return;
        }
        if (!this.resizeObserver) {
          this.resizeObserver = new ResizeObserver(() => {
            this.measureValues();
          });
        }
        this.resizeObserver.disconnect();
        this.rows.forEach((row, index) => {
          if (!this.truncatesValue(row)) return;
          const el = this.valueEl(index);
          if (el) this.resizeObserver.observe(el);
        });
        this.measureValues();
      });
    },

    measureValues() {
      const next = {};
      let changed = false;
      this.rows.forEach((row, index) => {
        if (!this.truncatesValue(row)) return;
        const el = this.valueEl(index);
        const truncated = !!(el && el.scrollWidth > el.clientWidth + 1);
        next[index] = truncated;
        if (this.truncated[index] !== truncated) changed = true;
      });
      if (Object.keys(this.truncated).length !== Object.keys(next).length) changed = true;
      if (changed) this.truncated = next;
    },
  },
};
</script>
